import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { Plus } from "lucide-react";

export interface RelatedContactsSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const RelatedContactsSection = ({ enduser }: RelatedContactsSectionProps) => {
  const [showAddRelatedContacts, setShowAddRelatedContacts] = useState(false);
  const { t } = useTranslation("contacts");

  const { breadcrumbs, actionButtons } = useMemo<
    Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs" | "actionButtons">
  >(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Related Contacts"),
        onClick: showAddRelatedContacts ? () => setShowAddRelatedContacts(false) : undefined,
      },
    ];
    if (showAddRelatedContacts) {
      breadcrumbs.push({
        title: t("Add Related Contacts"),
      });
    }

    const actionButtons: ContactDetailsSectionBreadcrumbsProps["actionButtons"] = showAddRelatedContacts
      ? undefined
      : [
          {
            hoverLabel: t("Add Related Contacts"),
            onClick: () => {
              setShowAddRelatedContacts(true);
            },
            icon: Plus,
          },
        ];

    return {
      breadcrumbs,
      actionButtons,
    };
  }, [showAddRelatedContacts, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs
        enduserId={enduser.id}
        breadcrumbs={breadcrumbs}
        actionButtons={actionButtons}
      />
      {showAddRelatedContacts ? (
        <ContactDetailsSections.AddRelatedContactForm
          contact={enduser}
          onSuccess={() => setShowAddRelatedContacts(false)}
          onCancel={() => setShowAddRelatedContacts(false)}
        />
      ) : (
        <ContactDetailsSections.RelatedContactsSection contact={enduser} />
      )}
    </div>
  );
};
